import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  styled,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { BRAND } from "../../styles/brand";

const steps = [
  "Received",
  "Analysis In Progress",
  "Analysis Complete",
  "Invoiced",
  "Paid",
];

const percentToStep = (percent) => {
  if (percent <= 0) return 0;
  if (percent <= 25) return 1;
  if (percent <= 50) return 2;
  if (percent <= 75) return 3;
  return 4;
};

// Gradient connector line
const GradientConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 11,
    left: "calc(-50% + 12px)",
    right: "calc(50% + 12px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 4,
    border: 0,
    borderRadius: 2,
    backgroundColor: "#e0e0e0",
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    background: `linear-gradient(to right, ${BRAND.primaryDark}, ${BRAND.primaryLight})`,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    background: `linear-gradient(to right, ${BRAND.primaryDark}, ${BRAND.primaryLight})`,
  },
}));

// Custom step icon
const StepIconRoot = styled("div")(({ ownerState }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color:
    ownerState.completed || ownerState.active ? BRAND.primary : "#bdbdbd",
  "& svg": {
    fontSize: 24,
  },
}));

function GradientStepIcon({ active, completed }) {
  return (
    <StepIconRoot ownerState={{ active, completed }}>
      {completed || active ? (
        <CheckCircleIcon />
      ) : (
        <RadioButtonUncheckedIcon />
      )}
    </StepIconRoot>
  );
}

export default function OrderProgressBar({ percentComplete }) {
  const activeStep = percentToStep(percentComplete);

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<GradientConnector />}
      sx={{ py: 1 }}
    >
      {steps.map((label, index) => (
        <Step key={label} completed={index < activeStep}>
          <StepLabel
            StepIconComponent={GradientStepIcon}
            sx={{
              "& .MuiStepLabel-label": {
                fontSize: "0.78rem",
                fontWeight: index < activeStep ? 600 : 400,
                color:
                  index < activeStep
                    ? BRAND.primary
                    : index === activeStep
                      ? BRAND.primaryDark
                      : "#9e9e9e",
                mt: 0.5,
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}